import get from 'lodash/fp/get'
import isEmpty from 'lodash/isEmpty'
import * as Elasticsearch from '../../../elasticsearch'
import * as Counters from '../counters'
import * as ReportUtils from '../utils'
import * as Types from './types'

const toTopArticle = (bucket: any): Types.TopArticle => {

  const allClicks = Counters.newCounterEntry(bucket)

  const postTypes = get(Elasticsearch.DocumentFieldNames.PostType, bucket)
  const recommended = ReportUtils.firstBucketEntry(postTypes, 'recommendation')

  const sourceNameBucket = get(Elasticsearch.DocumentFieldNames.SourceName, bucket)
  const sourceName = (sourceNameBucket && !isEmpty(sourceNameBucket.buckets)) ? sourceNameBucket.buckets[0].key : ''
  const suspectClickBuckets = get(Elasticsearch.DocumentFieldNames.SuspectClick, bucket)

  const suspectClickBucket = ReportUtils.firstBucketEntry(suspectClickBuckets, 1)
  const suspectClicks = Counters.newCounterEntry(suspectClickBucket)

  const realClickBucket = ReportUtils.firstBucketEntry(suspectClickBuckets, 0)
  const realClicks = Counters.newCounterEntry(realClickBucket)

  const issueIdBucket = get(Elasticsearch.DocumentFieldNames.IssueId, bucket)
  const issueId = issueIdBucket && !isEmpty(issueIdBucket.buckets) && issueIdBucket.buckets[0].key
  return {
    issueId,
    postId: bucket.key,
    realClick: realClicks,
    recommended: Counters.newCounterEntry(recommended),
    sourceName,
    suspectClick: suspectClicks,
    totalClick: allClicks,
  }
}

export const getTopArticles = (payload: any): Types.TopArticle[] => {
  return get('aggregations.post_id.buckets', payload).map((bucket: any) => toTopArticle(bucket))
}

const toArticleOpen = (bucket: any): Types.TopArticle => {
  const unique = get(Elasticsearch.AggFieldNames.UniqueCount, bucket)
  return {
    open: {
      total: {
        count: bucket[Elasticsearch.AggFieldNames.DocumentCount],
      },
      unique: {
        count: unique ? unique.value : bucket[Elasticsearch.AggFieldNames.DocumentCount],
      },
    },
    postId: bucket.key,
  }
}

export const getArticleOpens = (payload: any): Types.TopArticle[] => {
  return get('aggregations.post_id.buckets', payload).map((bucket: any) => toArticleOpen(bucket))
}

export const updateTopArticleOpens = (input: Types.TopArticle, newData: Types.TopArticle[]): Types.TopArticle => {
  return isEmpty(newData) ? input : {
    ...input,
    open: newData[0].open,
    realClick: Counters.updateUniqueRateFromOpens(input.realClick, newData[0].open),
    recommended: Counters.updateUniqueRateFromOpens(input.recommended, input.totalClick),
    suspectClick: Counters.updateUniqueRateFromOpens(input.suspectClick, newData[0].open),
    totalClick: Counters.updateUniqueRateFromOpens(input.totalClick, newData[0].open),
  }
}

export const updateTopArticleData = (input: Types.TopArticle, newData: Types.TopArticle[]): Types.TopArticle => {
  return isEmpty(newData) ? input : {
    ...input,
    sourceName: newData[0].sourceName || input.sourceName,
    title: newData[0].title || input.title || newData[0].url,
    url: newData[0].url || input.url,
  }
}

export const getPostDetails = (payload: any): Types.TopArticle[] => {
  return payload.results.map((d: any) => ({
    postId: d.id,
    title: d.title,
    url: d.url,
  }))
}

export const shareUrl = (communityGuid: string, a: Types.TopArticle, url: string) => {
  return !isEmpty(communityGuid) && a.issueId && url &&
         `${url}/${communityGuid}/${a.issueId}/${a.postId}`
}



// WEBPACK FOOTER //
// ./src/pages/reports/top-articles/utils.ts